module.exports = __webpack_public_path__ + "img/1726035273312-screenshot-1726035103445.png.f15ccd30.webp";